import {Checkbox} from 'primereact';
export const BodyModulo = (
  data,
  moduloCheckList,
  setModuloCheckList,
  setCheckList,
  setExpandedRows,
  setMenusCheckList
) => {
  const menusModulo =
    data.entidadesHijo.flatMap((d) => d.Menus)?.map((m) => m.IdSec) ?? [];

  return (
    <div className="modulo" style={{ display: "flex", gap: 10 }}>
      <Checkbox
        onChange={(e) => {
          if (moduloCheckList?.some((t) => t === data.key)) {
            setCheckList((prev) => {
              return prev.filter((v) =>
                data?.children?.some((f) => f.IdSec === v) ? false : true
              );
            });
            setMenusCheckList((prev) =>
              prev.filter((m) => !menusModulo.includes(m))
            );
            setModuloCheckList((prevValue) => [
              ...prevValue.filter((t) => t !== data.key),
            ]);
          } else {
            setCheckList((prev) => [
              ...prev,
              ...data?.children?.map((f) => f.IdSec),
            ]);
            setMenusCheckList((prevValue) => {
              const uniqueElements = new Set([...prevValue, ...menusModulo]);
              return Array.from(uniqueElements);
            });
            setModuloCheckList((prevValue) => [...prevValue, data.key]);
          }
        }}
        checked={moduloCheckList?.some((m) => m === data.key) ?? false}
      />
      <div
        style={{ width: "100%", cursor: "pointer", userSelect: "none" }}
        onClick={(e) => {
          setExpandedRows((prev) => {
            if (prev?.some((p) => p.key === data.key)) {
              return prev.filter((p) => p.key !== data.key);
            } else {
              return [...prev, data];
            }
          });
        }}
      >
        <span style={{ verticalAlign: "middle" }}>{data.label}</span>
      </div>
    </div>
  );
};
